module.exports = __webpack_public_path__ + "static/media/example4.ea43be20.gif";